var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoodStreakHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 63,
    viewBox: "0 0 72 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.2899 5.68747C62.6008 2.0204 57.6974 0 52.4798 0C47.2622 0 42.3642 2.0204 38.6751 5.68747L35.9952 8.35528L33.3208 5.69294C29.6309 2.0204 24.7274 0 19.5098 0C14.2922 0 9.39431 2.0204 5.70515 5.69372C-1.90172 13.2718 -1.90172 25.6014 5.70515 33.1795L34.2728 61.6184C34.7464 62.0899 35.3731 62.3284 35.9952 62.3284C36.0557 62.3284 36.1154 62.3252 36.1758 62.3213C36.8576 62.3721 37.5566 62.1376 38.0789 61.6176L61.8884 37.562C61.9285 37.5276 61.9622 37.4885 61.9968 37.4486L66.2907 33.1803C73.9031 25.6022 73.9031 13.2671 66.2907 5.68903L66.2899 5.68747Z",
    fill: "#726FB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0149 19.7434C48.3079 18.0995 46.0392 17.1938 43.6251 17.1938C41.211 17.1938 38.9447 18.0995 37.2378 19.7434L35.9979 20.9393L34.7605 19.7459C33.0532 18.0995 30.7844 17.1938 28.3703 17.1938C25.9562 17.1938 23.69 18.0995 21.9831 19.7462C18.4635 23.1433 18.4635 28.6703 21.9831 32.0674L35.2009 44.8159C35.4201 45.0272 35.7101 45.1341 35.9979 45.1341C36.0259 45.1341 36.0535 45.1327 36.0815 45.131C36.3969 45.1538 36.7203 45.0486 36.962 44.8155L47.9783 34.032C47.9969 34.0166 48.0125 33.999 48.0285 33.9812L50.0152 32.0678C53.5374 28.6707 53.5374 23.1412 50.0152 19.7441L50.0149 19.7434Z",
    fill: "#8780CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodStreakHeart);
export default __webpack_public_path__ + "static/media/mood-streak-heart.a7dd8dc0a1685d8f200041b8aee7adf4.svg";
export { ForwardRef as ReactComponent };